import React from 'react';
import styles from '../css/comuns/AppExclusivo.module.css';
import { config } from '../../data';

const AppExclusivo = () => {
    return (
        <div className={styles['oni-theme-variables']}>
            <div className={`container ${styles['top-banner']}`}>
                <div className={`row align-items-center mb-4 ${styles['banner-row']}`}>
                    <div className={`col-md-3 text-center ${styles['banner-logo']}`}>
                        <img src={config.images.appExclusivo.logo} alt="Logo Onigo" className={`${styles['img-fluid']} ${styles['logo-img']}`} loading="lazy" />
                    </div>
                    <div className={`col-md-9 ${styles['banner-text']}`}>
                        <a href={config.links.external.portalOnigo}>{config.texts.appExclusivo.banner.split('App Exclusivo')[0]}<strong>{config.texts.appExclusivo.destaque}</strong>{config.texts.appExclusivo.banner.split('App Exclusivo')[1]}</a>
                    </div>
                </div>
            </div>

            <main className="container">
                <div className={`row align-items-center ${styles['main-content']}`}>
                    <div className={`col-md-6 mb-4 mb-md-0 ${styles['image-container']}`}>
                        <div className={styles['image-wrapper']}>
                            <img src={config.images.appExclusivo.telas}
                                alt="Telas do aplicativo Onigo em diversos dispositivos" className="img-fluid" loading="lazy" />
                        </div>
                    </div>
                    <div className={`col-md-6 ${styles['text-content']}`}>
                        <h1>
                            {config.texts.appExclusivo.titulo}
                        </h1>
                        <div className={`d-flex gap-3 ${styles['controls']}`}>
                            <img src={config.images.appExclusivo.controles.play} alt="Botão Play" />
                            <img src={config.images.appExclusivo.controles.pause} alt="Botão Pause" />
                            <img src={config.images.appExclusivo.controles.retroceder} alt="Botão Retroceder" />
                            <img src={config.images.appExclusivo.controles.avancar} alt="Botão Avançar" />
                        </div>
                        <div className={styles['highlight']}>
                            {config.texts.appExclusivo.controles.play}<br />
                            {config.texts.appExclusivo.controles.pause}<br />
                            {config.texts.appExclusivo.controles.grave}<br />
                            {config.texts.appExclusivo.controles.quando}
                        </div>
                    </div>
                </div>
            </main>
        </div>
    );
};

export default AppExclusivo;